export default __webpack_public_path__ + "static/media/todo.6c7ff994.png";